import { ReactElement, cloneElement } from "react"

import InputHelpText from "@molecules/Form/inputs/Input/InputHelpText/InputHelpText"

import styles from "./InputInternalWrapper.module.scss"
import { InputInternalWrapperProps } from "./InputInternalWrapper.types"

const InputInternalWrapper = (props: InputInternalWrapperProps) => {
    const {
        label,
        indicator,
        inputHelpText,
        horizontalHelpText = false,
        children,
        isDisabled,
        isLoading,
        isError,
        ...rest
    } = props

    const helpTextIsString = typeof inputHelpText === "string"
    const helpTextIsArray = Array.isArray(inputHelpText)

    const renderInputMessage = () => {
        if (helpTextIsString) {
            return <InputHelpText status="neutral" message={inputHelpText} isLoading={isLoading} />
        } else if (helpTextIsArray) {
            const helpTextElements = inputHelpText.map((item, index) => (
                <InputHelpText key={index} {...item} isLoading={isLoading} />
            ))

            if (horizontalHelpText) {
                return <div className={styles.horizontalHelpText}>{helpTextElements}</div>
            } else {
                return helpTextElements
            }
        } else if (inputHelpText) {
            return <InputHelpText {...inputHelpText} isLoading={isLoading} />
        } else {
            return null
        }
    }

    return (
        <div className={styles.inputWrapperRoot} {...rest}>
            {label && (
                <div className={styles.labelWrap}>
                    {cloneElement(label as ReactElement, {
                        ...label.props,
                        state: isError ? "error" : label.props.state,
                        isDisabled,
                    })}
                    {indicator}
                </div>
            )}
            {children}
            {renderInputMessage()}
        </div>
    )
}

export default InputInternalWrapper
